const ChosenSelect = class ChosenSelect{
    constructor(config){
        this.chosenSelect = config.chosenSelect;
        this.chosenSelectScroll = config.chosenSelectScroll;
    }

    init(){
        this.showSelect();
    }

    showSelect(){
        const chosenScroll = this.chosenSelectScroll;

        this.chosenSelect.chosen({
            disable_search_threshold: 100,
            inherit_select_classes: true,
            width: '100%'
        }).on('chosen:showing_dropdown', function (evt, params) {
            $(this).parent().addClass('is-active');
            chosenScroll.find(".chosen-results").niceScroll({
                cursorcolor:"#24345c",
                cursorwidth:"4px",
                background:"#eeeeee",
                cursorborder:0,
                cursorborderradius:0,
                cursoropacitymin:1,
            });
        }).on('chosen:hiding_dropdown', function (evt, params) {
            $(this).parent().removeClass('is-active');

        }).on('change', function (evt, params) {
            $(this).parent().addClass('active-select');
        });
    }
};

export {ChosenSelect};


// WEBPACK FOOTER //
// ./static/js/components/ChosenSelect.js